import React from 'react';
import ListTooltip from '../v2/ui-elements/ListTooltip';
import Tooltip from '../v2/ui-elements/Tooltip';
import Text from '../v2/ui-elements/Text';

const EllipsesCountTooltip = ({ labels = [], prefix }) => {
  if (!labels.length) return null;

  return (
    <div style={{ display: 'flex', gap: '6px', width: '100%', alignItems: 'center' }}>
      {prefix && (
        <Text font="medium" className="SingleLine">
          {prefix}
        </Text>
      )}

      <Tooltip isIcon={true} title={labels[0]}>
        <Text font="medium" className="SingleLine">
          {labels[0]}
        </Text>
      </Tooltip>

      {labels.length > 1 && (
        <ListTooltip list={labels.slice(1)}>
          <div style={{ color: '#194BFB' }}>+{labels.length - 1}</div>
        </ListTooltip>
      )}
    </div>
  );
};

export default EllipsesCountTooltip;
